import React, {Component} from "react";
import {observer, inject} from "mobx-react";

import "../MenuLeft/common.css";

@inject("dialog")
@observer
class ImageHosting extends Component {
  showModal = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.props.dialog.setImageOpen(true);
  };

  render() {
    return (
      <a id="nice-navbar-image-hosting" className="nice-menu-link" href="#" onClick={this.showModal}>
        图床
      </a>
    );
  }
}

export default ImageHosting;
